module.exports = __webpack_public_path__ + "media/images/guide-3t-165ae535cbc8d3a66f0d86c1360e1ba4.png";